import Actions from '../actions/actions';
import PageActions from '../actions/PageCRUDActions';
import { PageState } from '../interfaces/page';
import {
  batchUpdate,
  localBatchUpdate,
  retrievedAll,
  setBusy,
  setUnBusy,
  update,
} from './common/commonReducers';

const initialState: PageState = {
  busy: false,
  entities: [],
  dropdown: [],
};

export default function page(state = initialState, action): PageState {
  switch (action.type) {
    case PageActions.busyAction:
      return setBusy(state);
    case PageActions.retrievedAction:
      return update(state, action);
    case PageActions.retrievedByGroupId: {
      if (Array.isArray(action.payload)) {
        return batchUpdate(state, {
          entities: action.payload,
          appendNew: true,
        });
      }
      return state;
    }
    case PageActions.retrievedAllAction:
      return retrievedAll(state, action);
    case PageActions.updateAction:
      return update(state, action);
    case PageActions.retrievedBatchAction:
      return batchUpdate(state, action);
    case PageActions.localBatchUpdateAction:
      return localBatchUpdate(state, action);

    case PageActions.retriveDropdownPagesAction: {
      const allPages = action.payload;
      const firstUnsubscribe = allPages.findIndex(
        d => d.name === 'Unsubscribe Dialogue',
      );

      const pagesWithoutDefaultUnsubscribe = firstUnsubscribe
        ? allPages.filter(p => p.id !== firstUnsubscribe.id)
        : allPages;

      return {
        ...state,
        dropdown: allPages,
        entities: pagesWithoutDefaultUnsubscribe,
        busy: false,
      };
    }

    case PageActions.resetAction:
    case Actions.RESET:
      return initialState;
    case PageActions.unbusyAction:
    case Actions.UNBUSY:
      return setUnBusy(state);
    default:
      return state;
  }
}
